import React from 'react';
import { CheckIcon, Icon, ModalButton, Button } from 'components/ui';
import IconList from 'components/icons_list/list';
import { useI18n } from 'hooks/use_i18n';
import { formValueSelector } from 'redux-form';
import { useSelector } from 'react-redux';

const FormIconSelector = (props) => {
  const {
    input: { onChange, name },
    label,
    meta: { form },
    disabled,
  } = props;
  const selector = formValueSelector(form);
  const icon = useSelector((state) => {
    return selector(state, name);
  });
  const { t } = useI18n();
  return (
    <div className="d-flex align-center">
      <span className="mr-1">{label || t('components.ui.form.icon_selector.icon_label')}</span>
      {!icon && <CheckIcon check={false} className="mr-1" />}
      {icon && <Icon name={icon} className="mr-1" />}
      <ModalButton
        color="default"
        size="sm"
        modalTitle={t('components.ui.form.icon_selector.select_icon_modal_title')}
        modalProps={{
          size: 'lg',
        }}
        buttonLabel={icon ? t('components.ui.form.icon_selector.change_icon') : t('components.ui.form.icon_selector.select_icon')}
        disabled={disabled}
      >
        {({ closeModal }) => {
          return (
            <div className="p-2">
              <IconList
                onIconClick={(iconToSelect) => {
                  return onChange(iconToSelect);
                }}
                selectedIcon={icon}
                disabled={disabled}
              />
              <p className="text-center mt-1">
                <Button
                  color="primary"
                  disabled={!icon}
                  onClick={() => {
                    return closeModal();
                  }}
                >
                  {t('components.ui.form.icon_selector.use_selected_icon')}
                </Button>
              </p>
            </div>
          );
        }}
      </ModalButton>
    </div>
  );
};

FormIconSelector.defaultProps = {
  disabled: false,
};

export default FormIconSelector;
